import { Interval } from '@tonaljs/tonal';
const majorKey = ["C","Db","D","Eb","E","F","Gb","G","Ab","A","Bb","B"];
const minorKey = ["A","Bb","B","C","C#","D","Eb","E","F","F#","G","G#"];


const majorBb =  ["D","Eb","E","F","Gb","G","Ab","A","Bb","B","C","Db"];
const majorEb =  ["A","Bb","B","C","Db","D","Eb","E","F","Gb","G","Ab"];

function getKeyTransposedBySemitones(keytonic, isMajor, semitones)
{
  
  let res = isMajor ? majorKey[(majorKey.indexOf(keytonic)+semitones)%12] : minorKey[(minorKey.indexOf(keytonic)+semitones)%12];
  //console.log(`keytonic ${keytonic}, isMajor ${isMajor}, semitones ${semitones}, result ${res}`)
  return res;
}

// TODO vi måste veta vilken quality som key har, annars hittar vi kanske inte key i korrekt array
// Samma problem i getKeyTransposedBySemitones?
function getKeyTransposedByInterval({ key, transposeInterval })
  {
    let newKey = key;
    let transposeLevel = 0;
    if (transposeInterval && typeof transposeInterval === "string") {
      const { sub, add, interval, quality } = /^((?<sub>-*)(?<add>\+*)(?<interval>[1-8][PmMdA]))(?<quality>m)?/.exec(
        transposeInterval,
      )?.groups || { sub:"", add:"", interval: "", quality: "M" };
      if (interval!=="") // <interval> "1P"
      {
        transposeLevel = add.length-sub.length;
        if (Interval.semitones(interval)) {
          newKey = getKeyTransposedBySemitones(key, quality === "m" ? false : true, Interval.semitones(interval)); // // <quality>, "m"=minor otherwise major
          //console.log(`Transpose ${props.t} to ${newT}, level: ${transposeLevel}`);
        }
      }
    }
    return { newKey: newKey, transposeLevel: transposeLevel};
  }

function getCurrentKey(currentKeyIndex, isMajor)
{
  if(currentKeyIndex<0){
    currentKeyIndex = 12+currentKeyIndex;
  }
  return isMajor ? majorKey[currentKeyIndex%12] : minorKey[currentKeyIndex%12];
}

function getKeyIndex(keytonic, isMajor)
{
  return isMajor ? majorKey.indexOf(keytonic) : minorKey.indexOf(keytonic) ;
}

function changeKeyIndex(interval, currentKeyIndex) {
    return (currentKeyIndex + Interval.get(interval).semitones) % 12;
}

function transposeToInstrumentKey(instrument, tonic, isMajor){
  if(instrument==='C'){
    return tonic;
  }
  let index = getKeyIndex(tonic, isMajor);
  switch(instrument){
    case "Bb":
      return getCurrentKey(index+2, isMajor);
    case "Eb":
      return getCurrentKey(index-3, isMajor);
    default:
      return tonic;
  }
}

/* function transposeMajorKeyToBbInstrument(tonic)
{
  return majorBb[majorKey.indexOf(tonic)];
}

function transposeMajorKeyToEbInstrument(tonic)
{
  return majorEb[majorKey.indexOf(tonic)];
} */

export { majorKey, minorKey, transposeToInstrumentKey, getCurrentKey, changeKeyIndex, getKeyIndex, getKeyTransposedBySemitones, getKeyTransposedByInterval }